module.exports = __webpack_public_path__ + "img/banner1.fb4d8db7.png";